import { render, staticRenderFns } from "./ScrollRanking.vue?vue&type=template&id=57d70449&scoped=true&"
import script from "./ScrollRanking.vue?vue&type=script&lang=js&"
export * from "./ScrollRanking.vue?vue&type=script&lang=js&"
import style0 from "./ScrollRanking.vue?vue&type=style&index=0&id=57d70449&prod&lang=scss&"
import style1 from "./ScrollRanking.vue?vue&type=style&index=1&id=57d70449&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d70449",
  null
  
)

export default component.exports